import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Spinner from "../../common/Spinner";
import UserAvatar from 'react-user-avatar';
import * as apiConfig from "../../../api/config";
import ProfileNetwork from "./ProfileNetwork"
import UserGroupsView from "../../groups/UserGroupsView"
import { loadSubjectUser } from "../../../redux/actions/userActions";
import { setupNavigation } from "../../../redux/actions/navItemsActions";
import { removefollowingRider, blockRider, unblockRider, followRider, unfollowRider } from "../../../redux/actions/riderNetworkActions";
import FollowerRequestControl from "./FollowerRequestControl";
import ProfileNetworkControl from "./ProfileNetworkControl";
import RouteSearch from "../../routes/RouteSearch";
import PostFeedControl from "../../postComments/PostFeedControl";
import { toast } from "react-toastify";
import "./ProfilePage.css";
import { checkLogin } from "../../../redux/actions/authActions";


function ProfileUserPage(
    {
        setupNavigation,
        user,
        subjectUserId,
        loadSubjectUser,
        removefollowingRider,
        blockRider,
        unblockRider,
        followRider,
        unfollowRider,
        checkLogin,
        history,
        ...props
    }
) {

    const [activeForm, setActiveForm] = useState({ form: "timeline" });
    const [subjectUser, setSubjectUser] = useState(undefined);
    const [processing, setProcessing] = useState(true);
    const [showProfile, setShowProfile] = useState(true);
    const [hiddenProfileMessage, setHiddenProfileMessage] = useState({});
    const [networkConnection, setNetworkConnection] = useState({});

    const navigationItems =
    {
        sections: [{
            name: 'Routes',
            items: [
                {
                    path: '/user/profile',
                    text: 'Timeline',
                    icon: 'fas fa-clock'
                },
                {
                    path: '/user/routes',
                    text: 'My Routes',
                    icon: 'fas fa-route'
                },
                {
                    path: '/user/bookmarks',
                    text: 'Bookmarked Routes',
                    icon: 'fas fa-star'
                }
            ]
        },
        {
            name: 'Settings',
            items: [
                {
                    path: '/user/settings/general',
                    text: 'Settings',
                    icon: 'fas fa-cog'
                }
            ]
        }]
    };

    useEffect(() => {
        if (subjectUserId.toLowerCase() == user.id.toLowerCase()) {
            history.push("/user/profile")
        }
        document.title = "View User Profile | JustGoRide";

        setupNavigation(navigationItems);

    }, []);

    useEffect(() => {
        checkLogin().then(() => {
            if (subjectUserId.toLowerCase() == user.id.toLowerCase()) {
                history.push("/user/profile")
            }

            setActiveForm(setActiveForm => ({
                ...setActiveForm,
                form: "timeline"
            }));

            if (!subjectUser || subjectUser.id.toUpperCase() != subjectUserId.toUpperCase()) {
                setProcessing(true);
                loadSubjectUser(subjectUserId)
                    .then((subject) => {
                        setSubjectUser(subject)
                        setProcessing(false);
                    })

            }
            else {
                processNetworkConnection();

            }
        })
    }, [subjectUserId]);

    useEffect(() => {
        processNetworkConnection(); 
    }, [user, subjectUser])

    useEffect(() => {
        if (props.location.state && props.location.state.source == "notifications") {
            setProcessing(true);
            checkLogin()
        }
    }, [props.location])


    function processNetworkConnection() {
        var you = { connected: false, pending: false, blocked: false};
        var them = { connected: false, pending: false, blocked: false };

        if (user.riderNetwork.followers) {
            user.riderNetwork.followers.map(subject => {
                if (subject.userId.toUpperCase() == subjectUserId.toUpperCase()) {
                    them.connected = !subject.pending && !subject.blocked;
                    them.pending = subject.pending;
                    them.blocked = subject.blocked;
                }
            })
        }

        if (user.riderNetwork.following) {
            user.riderNetwork.following.map(subject => {
                if (subject.userId.toUpperCase() == subjectUserId.toUpperCase()) {
                    you.connected = !subject.pending && !subject.blocked;;
                    you.pending = subject.pending;
                    you.blocked = subject.blocked;
                }

            })
        }

        setShowProfile(true);
        if (subjectUser) {
            if (subjectUser.approveFollowers && !(you.connected || you.pending)) {
                setShowProfile(false);
                setHiddenProfileMessage({ message: `Submit a request to follow ${subjectUser.firstName} to view their profile.`, icon: "fas fa-user-plus" })
            }
            if (subjectUser.approveFollowers && you.pending) {
                setShowProfile(false);
                setHiddenProfileMessage({ message: `Your request to follow ${subjectUser.firstName} is pending approval.`, icon: "fas fa-clock" })
            }
            if (you.blocked || (them.blocked && subjectUser.approveFollowers)) {
                setShowProfile(false);
                setHiddenProfileMessage({ message: "Profile unavailable.", icon: "far fa-times-circle" })
            }
        }

        setNetworkConnection({ you: you, them: them })
        if (subjectUser) {
            setProcessing(false);
        }
    }

    function setForm(e) {
        e.preventDefault();
        var form = e.target.title;
        setActiveForm(setActiveForm => ({
            ...setActiveForm,
            form: form
        }));
    }

    function followUser(e) {
        e.preventDefault();
        followRider(subjectUser, subjectUser.approveFollowers);
        toast.success(subjectUser.approveFollowers ? "Follow Request Submitted" : `Following ${subjectUser.firstName}`);
    }

    function unfollowUser(e) {
        e.preventDefault();
        unfollowRider(subjectUser);
        toast.success(networkConnection.you.pending ? "Follow Request Cancelled" : `Unfollowed ${subjectUser.firstName}`);
    }

    function removeFollower(e) {
        e.preventDefault();
        removefollowingRider(subjectUser);
        toast.success(`${subjectUser.firstName} no longer follows you`);
    }

    function blockFollower(e) {
        e.preventDefault();
        blockRider(subjectUser);
        toast.success(`${subjectUser.firstName} Blocked`);
    }

    function unblockFollower(e) {
        e.preventDefault();
        unblockRider(subjectUser);
        toast.success(`Unblocked ${subjectUser.firstName}`);
    }

    return (
        processing ?
            <Spinner />
            :
            <div>
                <div className="profile-banner">
                    <div className="profile-banner-bg-img-gradient"></div>
                    {subjectUser.bannerAvailable &&
                        <img className="profile-banner-bg-img" src={`${apiConfig.API_URL}user/banner/${subjectUser.id}.png?v=${subjectUser.bannerVersion}`} />
                    }
                    <ProfileNetworkControl
                        subjectUser={subjectUser}
                        networkConnection={networkConnection}
                        onFollowUser={followUser}
                        onUnfollowUser={unfollowUser}
                        onRemoveFollower={removeFollower}
                        onBlockUser={blockFollower}
                        onUnblockUser={unblockFollower}
                     />
                </div>
                
                {!showProfile ?
                    <div className="profile-unavailble-message">
                        <span className={`${hiddenProfileMessage.icon} profile-unavailble-icon`}></span>
                        {hiddenProfileMessage.message}
                    </div>
                    : 
                    <React.Fragment>
                        <div className="profile-tab">
                            <ul className="nav nav-tabs">
                                <li className="nav-item">
                                    <a title="timeline" className={activeForm.form == "timeline" ? "nav-link d-sm-none active" : "nav-link d-sm-none"} href="#" onClick={setForm}><span title="timeline" className="fas fa-clock"></span></a>
                                    <a title="timeline" className={activeForm.form == "timeline" ? "nav-link d-none d-sm-inline active" : "nav-link d-none d-sm-inline"} href="#" onClick={setForm}><span title="timeline" className="fas fa-clock mr-1"></span>Timeline</a>
                                </li>
                                <li className="nav-item">
                                    <a title="routes" className={activeForm.form == "routes" ? "nav-link d-sm-none active" : "nav-link d-sm-none"} href="#" onClick={setForm}><span title="routes" className="fas fa-route"></span></a>
                                    <a title="routes" className={activeForm.form == "routes" ? "nav-link d-none d-sm-inline active" : "nav-link d-none d-sm-inline"} href="#" onClick={setForm}><span title="routes" className="fas fa-route mr-1"></span>Routes</a>
                                </li>
                                <li className="nav-item">
                                    <a title="network" className={activeForm.form == "network" ? "nav-link d-sm-none active" : "nav-link d-sm-none"} href="#" onClick={setForm}><span title="network" className="fas fa-user-friends"></span></a>
                                    <a title="network" className={activeForm.form == "network" ? "nav-link d-none d-sm-inline active" : "nav-link d-none d-sm-inline"} href="#" onClick={setForm}><span title="network" className="fas fa-user-friends mr-1"></span>Network</a>
                                </li>
                                <li className="nav-item">
                                    <a title="groups" className={activeForm.form == "groups" ? "nav-link d-sm-none active" : "nav-link d-sm-none"} href="#" onClick={setForm}><span title="groups" className="fas fa-users"></span></a>
                                    <a title="groups" className={activeForm.form == "groups" ? "nav-link d-none d-sm-inline active" : "nav-link d-none d-sm-inline"} href="#" onClick={setForm}><span title="groups" className="fas fa-users mr-1"></span>Groups</a>
                                </li>
                            </ul>
                        </div>
                        <div>
                            {
                                (() => {
                                    switch (activeForm.form) {
                                        case "timeline":
                                            return (
                                                <PostFeedControl mode={"User"} subjectUserId={subjectUserId} />
                                            )
                                        case "routes":
                                            return (
                                                <RouteSearch mode={"subjectUser"} subjectUserId={subjectUserId} />
                                            )
                                        case 'network':
                                            return (
                                                <ProfileNetwork subjectUser={subjectUser}  />
                                            )
                                        case 'groups':
                                            return (
                                                <UserGroupsView subjectUser={subjectUser} />
                                            )
                                        default:
                                            return null;
                                    }
                                })()
                            }
                        </div>
                    </React.Fragment>
                }
            </div>

    );


}

ProfileUserPage.propTypes = {
    setupNavigation: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    subjectUserId: PropTypes.string.isRequired,
    subjectUser: PropTypes.object,
    loadSubjectUser: PropTypes.func.isRequired,
    removefollowingRider: PropTypes.func.isRequired,
    blockRider: PropTypes.func.isRequired,
    unblockRider: PropTypes.func.isRequired,
    followRider: PropTypes.func.isRequired,
    unfollowRider: PropTypes.func.isRequired,
    checkLogin: PropTypes.func.isRequired
}

function mapStateToProps(state, ownProps) {
    const id = ownProps.match.params.id;
    return {
        subjectUserId: id,
        user: state.user
    };
}

const mapDispatchToProps = {
    setupNavigation,
    loadSubjectUser,
    removefollowingRider,
    blockRider,
    unblockRider,
    followRider,
    unfollowRider,
    checkLogin
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileUserPage);




// WEBPACK FOOTER //
// ./src/components/user/profile/ProfileUserPage.js